import { useQuery } from '@tanstack/react-query';
import { UseQueryOptions } from '@tanstack/react-query';
import { ProfessionalUnavailabilityService } from '../professional-unavailability.service';

export const useGetProfessionalUnavailability = (
	params: ProfessionalUnavailabilitys.UnavailabilityParams,
	options?: Omit<
		UseQueryOptions<
			ProfessionalUnavailabilitys.GetUnavailabilityRespose,
			Error
		>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: [
			'professional-unavailability',
			params.date_a,
			params.date_b,
			params.page,
			params.limit,
		],
		queryFn: () => ProfessionalUnavailabilityService.get(params),
		refetchOnWindowFocus: false,
		...options,
	});
};
